import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";


// material ui
import { Grid } from "@mui/material";
// material icon
import CancelIcon from "@mui/icons-material/Cancel";
// components
import AssessmentFrameworkDimensionConfig from "./AssessmentTemplateDimensionFramework";
import AssessmentFrameworkSectionConfig from "./AssessmentTemplateSectionFramework";
import Layout from "../../../../../layout/Layout";
import { useDispatch } from "react-redux";
// import { sectionRowSelect } from "../../../../../../../features/config/assessmentTemplateSectionConfigSlice";
import { AppPageHeader, PageHeader } from "../../../../../components";
// import {
//   rowSelect,
//   sectionRowSelect,
// } from "../../../../../features/config/assessmentTemplateSectionConfigSlice";

import { 

  rowSelect,
  sectionRowSelect,
} from "../../../../../features/config/assessmentFrameworkSectionConfigSlice";
import { useSelector } from "react-redux";





const ConfigureAssessmentTemplateConfig = (props) => {

  
 const { customerValue,accountValue } = useSelector((state) => ({
    ...state.auth,
  }));

  const location = useLocation();
  const dispatch = useDispatch();

  let shrink = props.sidebar ? "scale" : "no-scale";
 

  useEffect(() => {
    try {
     
        dispatch(rowSelect({}));
        dispatch(sectionRowSelect({}));
    
    } catch (err) {
    
    }
  }, []);

  // console.log(customerValue)
  // console.log(accountValue)

  console.log("locatino",location)

  return (
    <Layout>
      {/* <Link
        to={{
          pathname: "/piedap/assessment360/config/assessment_template",
          serviceAccessData : location?.serviceAccessData
        }}
      >
        <CancelIcon
          color="red"
          sx={{ position: "absolute", right: 80, zIndex: 1 }}
          onClick={() => dispatch(sectionRowSelect(""))}
        />
      </Link> */}
      <AppPageHeader
        variant="pageHeader"
        pathname="/exco/config/assessment-framework"
        permissions={location?.state?.permissions}
        l3Menu={location?.state?.l3Menu}
        data={location?.state?.data}
        moduleName={location?.state?.moduleName}
        assessmentType={location?.state?.assessmentType}
        selectedCustValue= {location?.state?.selectedCustValue}
        selectedAccountValue= {location?.state?.selectedAccountValue}
      >
        {location?.state?.templateSelectedData?.assessmentTemplateName
          ? location?.state?.templateSelectedData?.assessmentTemplateName
          : ""}
      </AppPageHeader>
      <Grid container spacing={2} >
        <Grid item xs={12} sm={12} md={6}>
          <AssessmentFrameworkSectionConfig
            fromMain={location.fromMain}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <AssessmentFrameworkDimensionConfig />
        </Grid>
      </Grid>
    </Layout>
  );
};

export default ConfigureAssessmentTemplateConfig;
